
<div class="similar-cards" v-if="cards.length > 0">
  <align class="header" flex>
    <h4 class="secondary-font">Similar</h4>

    <icon-link
      v-if="!isPublic && ids.length"
      @click="$router.push(`/compare?ids=${ids}`)"
    >
      Compare all
    </icon-link>
  </align>

  <div class="list">
    <card-list-item
      v-for="card in cards"
      :key="card.id"
      :card="card"
      :fields="['currentValue']"
      :to="getCardTo(card.id)"
      as="router-link"
    />
  </div>
</div>
